/* eslint-disable */
export default `
THIS IS BROKEN, _ESPECIALLY_ ON FIREFOX


............................................________ 
....................................,.-'"...................\`\`~., 
.............................,.-"..................................."-., 
.........................,/...............................................":, 
.....................,?......................................................, 
.................../...........................................................,} 
................./......................................................,:\`^\`..} 
.............../...................................................,:"........./ 
..............?.....__.........................................:\`.........../ 
............./__.(....."~-,_..............................,:\`........../ 
.........../(_...."~,_........"~,_....................,:\`........_/ 
..........{.._$;_......"=,_......."-,_.......,.-~-,},.~";/....} 
...........((.....*~_......."=-._......";,,./\`..../"............../ 
...,,,___.\`~,......"~.,....................\`.....}............../ 
............(....\`=-,,.......\`........................(......;_,,-" 
............/.\`~,......\`-...................................../ 
.............\`~.*-,.....................................|,./.....,__ 
,,_..........}.>-._...................................|..............\`=~-, 
.....\`=~-,__......\`,................................. 
...................\`=~-,,.,............................... 
................................\`:,,...........................\`..............__ 
.....................................\`=-,...................,%\`>--==\`\` 
........................................_..........._,-%.......\` 
..................................., 
`;
